import axios from '../Axios/Default';
import { handleResponse } from '../Utils/Utils';

export const getSegmentAll = (_params, onSuccess, onError) => {
    const response = axios.get('v1/admin/segment', { params: _params });
    return handleResponse(response, onSuccess, onError);
};

export const getSegmentById = (id, onSuccess, onError) => {
    const response = axios.get(`v1/admin/segment/${id}`);
    return handleResponse(response, onSuccess, onError);
};

export const createSegment = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/admin/segment`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const updateSegment = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/segment/${id}`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const softDeleteSegment = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/segment/${id}/delete`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const deleteSegment = (id, onSuccess, onError) => {
    const response = axios.delete(`v1/admin/segment/${id}`);
    return handleResponse(response, onSuccess, onError);
};